import { lccstate, registry } from 'lcc-state';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { DNode } from '@dojo/framework/core/interfaces';
import { resize } from '@dojo/framework/core/middleware/resize';
import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v, w } from '@dojo/framework/core/vdom';
// import { logLp } from 'logger';
import { ActiveView } from '@holmescorp/explore-view';
import { cssProperty } from '@holmescorp/middleware/css-property';
import { TocSlidePane } from '@holmescorp/table-of-contents';

import css from '../css/content.m.css';

// eslint-disable-next-line @typescript-eslint/no-unused-vars

registry.define('ActiveView', ActiveView);
registry.define('TocSlidePane', TocSlidePane);

export interface ContentProperties {
	showNoSession?: boolean;
}

const factory = create({ theme, lccstate, cssProperty, resize }).properties<ContentProperties>();

export const Content = factory(({ properties, middleware: { theme, cssProperty, resize /*, lccstate */ } }) => {
	const { showNoSession = false } = properties();

	const rect = resize.get('content-main');
	if (rect) {
		const { width } = rect;
		// subtract to allow for margins & scrollbar
		const margins = width > 1295 ? 0 : 15;
		const contentwidth = Math.max(Math.min(width, 1280), 375) - margins;
		cssProperty.set('content-main', '--lcc-content-width', `${contentwidth}px`);
	}

	const themeCss = theme.classes(css);

	const kids = ((): DNode[] => {
		return [
			w('PageGroup', {
				kids: [
					{ widget: 'Widget', realwidget: 'TocSlidePane', name: 'toc-slide-pane' },
					{ widget: 'Widget', realwidget: 'ActiveView', name: 'active-view' }
				]
			})
		];
	})();

	const noSession = [
		v('div', { classes: [themeCss.noSession], xqa: 'no-session-warning' }, [
			v('p', {}, [
				'You have reached this page in error. Please click the link below to select the correct product for your studies.'
			]),
			v('p', { xqa: 'no-session-link' }, [v('a', { href: '/am/@@welcome' }, ['Choose Product'])])
		])
	];

	return v(
		'main',
		{ id: 'content-main', key: 'content-main', role: 'main', classes: [theme.variant(), themeCss.root] },
		showNoSession ? noSession : kids
	);
});
